module.exports = __webpack_public_path__ + "static/Scroll Group 1-b485c7891c02b15bfdf787b3db980a1b.png";